import { FaInstagram } from "react-icons/fa";
import {AiOutlineFacebook} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiOutlineLinkedin} from 'react-icons/ai'

export const links = [
    {id: 1, link: '#', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    /*{id: 3, link: '#services', title: 'Services'},*/
    {id: 3, link: '#portfolio', title: 'Portfolio'},
    {id: 4, link: '#contact', title: 'Contact'}
]


export const socials = [
    {id:1, link: 'https://www.linkedin.com/in/stamatis-platokoukis/', icon: <AiOutlineLinkedin/>},
    {id:2, link: 'https://github.com/stplato', icon: <AiFillGithub/>},
    {id:3, link: 'https://www.instagram.com/stamplato/', icon: <FaInstagram />},
    {id:4, link: 'https://www.facebook.com/platokoukis.stamatis', icon: <AiOutlineFacebook/>}
    
    
]